<template>
  <main class="app">
    <div class="landing-container">
      <div class="text" ref="text1">안녕하세요</div>
      <div class="text" ref="text2">
        <span :style="{ color: '#fd853a' }">주도적인 개발자</span>
      </div>
      <div class="text" ref="text3">김성민입니다.</div>
      <div class="half-circle"></div>
    </div>
  </main>
</template>

<style scoped>
.app {
  height: 100vh;
}

.landing-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100%;
}

.text {
  opacity: 0;
  color: #171717;
  display: flex;
  gap: 10px;
  text-align: center;
  font-size: 3em;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.975px;
}

.text span {
  color: #fd853a;
}

.half-circle {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 0;
  width: 432px;
  height: 140px;
  border-top-right-radius: 1000px;
  border-top-left-radius: 1000px;
  background: #feb273;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.text-enter-active {
  animation: fadeInUp 1s ease-out;
  animation-fill-mode: forwards; /* Retain styles after animation */
}
</style>

<script>
export default {
  mounted() {
    this.$refs.text1.classList.add('text-enter-active');
    this.$refs.text2.classList.add('text-enter-active');
    this.$refs.text3.classList.add('text-enter-active');
  },
};
</script>
